import formatDate from './formatDate';
import History from '@/types/onboardingHistory';
export default function setPendencyProfile(history: History): string {
  return formatDate(history.date) + ` - ${history.user.split('@')[0]}(${history.updatedAs}): `;
}
